// extracted by mini-css-extract-plugin
module.exports = {"tranSection":"style_tranSection__2JRKg","tranWrap":"style_tranWrap__BejQu","tranBox":"style_tranBox__3pgpy","dtFont":"style_dtFont__rTB8U"};